import moment from "moment";

/**
 * Billed day count for a stay.
 * Search Option C uses startTime/endTime 0 (midnight defaults) → a one-calendar-day
 * span bills as 1 day. After the guest sets times, a span whose clock hours exceed
 * 24 can bill as 2 days — that jump is intentional billing, not a search bug.
 */
const dayDifferenceHelper = ({ startTime, endTime, startDate, endDate }) => {

    let momentStartDate, momentEndDate, dayDifference;
    momentStartDate = moment(startDate);
    momentEndDate = moment(endDate);
    dayDifference = momentEndDate.diff(momentStartDate, 'days');

    if (dayDifference == 1) {
        dayDifference = (Number((24 - startTime)) + Number(endTime)) <= 24 ? 1 : 2;
    } else { dayDifference += 1; }

    return dayDifference;

};

export default dayDifferenceHelper;


export async function utcDateFormat(date) {
    return moment.utc(date).format('YYYY-MM-DD');
}

export async function dateFormat(date) {
    return moment(date).format('YYYY-MM-DD')
}
